import React from 'react';
import '../pages/LandingPage.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
    <div className="container">
      <div className="footer-content">
        <div className="footer-section">
          <div className="logo">
            <img src="/logo.png" alt="Figbot Logo" className="logo-icon" />
            <span className="logo-text">Figbot</span>
          </div>
          <p>Transform documents into intelligent chatbots.</p>
        </div>
        <div className="footer-section">
          <h4>Product</h4>
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <Link to="/dashboard">Dashboard</Link>
        </div>
        <div className="footer-section">
          <h4>Company</h4>
          <Link to="/about">About</Link>
          <a href="#contact">Contact</a>
          <a href="#blog">Blog</a>
        </div>
        <div className="footer-section">
          <h4>Legal</h4>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/security">Security</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Figbot. All rights reserved.</p>
      </div>
    </div>
  </footer>
  )
}

export default Footer